import axios from 'axios';

import {
    FETCHING_EXTERNAL_LIBRARY,
    FETCHING_EXTERNAL_LIBRARY_SUCCEDED,
    FETCHING_EXTERNAL_LIBRARY_FAILED,
    RESET_EXTERNAL_LIBRARY
} from './actionTypes.jsx';

const apiUrl = process.env.REACT_APP_API_URL;


const EXTERNAL_LIBRARY_BASE_URL = `${apiUrl}/api/2.0/external_library`

export function fetchExternalLibrary(data) {
    return function (dispatch) {
        dispatch(fetchingExternalLibrary(FETCHING_EXTERNAL_LIBRARY));
        return axios({
            method: "GET",
            url: EXTERNAL_LIBRARY_BASE_URL,
            params: data
        }).then(response =>
            dispatch(fetchingExternalLibrarySucceded(FETCHING_EXTERNAL_LIBRARY_SUCCEDED, response.data))
        ).catch(error =>
            dispatch(fetchingExternalLibraryFailed(FETCHING_EXTERNAL_LIBRARY_FAILED, error))
        )
    };
}

export function resetExternalLibrary() {
    return {
        type: RESET_EXTERNAL_LIBRARY,
        payload: {}
    }
}

function fetchingExternalLibrary(type) {
    return {
        type: type,
        payload: {},
    };
}

function fetchingExternalLibrarySucceded(type, json) {
    return {
        type: type,
        payload: json,
    };
}

function fetchingExternalLibraryFailed(type, error) {
    return {
        type: type,
        payload: {
            error: error,
        },
    };
}
